module.exports = __webpack_public_path__ + "img/DSC_0180 teatro 1.f94010aa.jpg";